import { Action, IconButton, Spacing } from "@bonusx-global/bx-design-system";
import { ArrowLeftOutlined } from "@bonusx-global/bx-icons";
import type { IconButtonProps } from "@mui/material";
import useIsMobile from "../../../../hooks/device/useIsMobile";

interface BackIconButtonProps extends IconButtonProps {}

function BackIconButton(props: BackIconButtonProps): JSX.Element {
  const isMobile = useIsMobile();

  return (
    <IconButton sx={{ color: Action.active, marginRight: isMobile ? Spacing["500"] : Spacing["0"] }} {...props}>
      <ArrowLeftOutlined />
    </IconButton>
  );
}

export default BackIconButton;
